module.exports = __webpack_public_path__ + "img/photos/news/big/02@2x.jpg";